import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Navbar, Button } from 'react-bootstrap';
//Images
import logo from '../../assets/img/logo-white.png';
import './NavigationBar.css';

export const NavigationBar = () => {
    const { instance } = useMsal();

    const handleLogoutRedirect = () => {

        instance
            .logoutRedirect()
            .catch((error) => console.log(error));

    };

    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            <Navbar variant="dark" className="navbarStyle gradient-background-new">

                <img className="brand-img img-fluid mr-50" src={logo} alt="brand" width="175" />

                <a className="navbar-brand" href="/">
                    <small>Supply Chain Resiliency</small>
                </a>

                <AuthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <Button variant="warning" onClick={handleLogoutRedirect}>
                            Sign out
                        </Button>
                    </div>
                </AuthenticatedTemplate>

                {/* <UnauthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <Button onClick={handleLoginRedirect}>Sign in</Button>
                    </div>
                </UnauthenticatedTemplate> */}
            </Navbar>
        </>
    );
};
